import 'reflect-metadata'
import { injectable } from 'inversify-props'
import { EstoqueServiceAdapter, FiltroDeEstoques } from '@/usecases/deposito/adapter/EstoqueServiceAdapter'
import {
	createEstoque,
	adicionarQtdeEstoque,
	retirarQtdeEstoque,
	empenharEstoque,
	reaverEstoque,
	deletarEstoque,
	montarEstoque,
	desmontarEstoque,
	buscarEstoques,
	encontrarProdutoComEstoque,
	getEstoque,
	importaItens,
	getEstoqueDoItemDaVendaNaLoja,
	exportEstoque,
	alterarEstoqueMinimo,
	encontrarProdutoComEstoqueRomaneio,
} from '@/api/deposito'
import { Estoque, EstoqueCsvForm, EstoqueProjection, FiltroDaTelaDeEstoques, FormDeItemDeEstoque, Page } from '@/models'
import { FormDeConversaoDeEstoque } from '@/models/estoque/ConversaoDeEstoque'
import { AxiosRequestConfig } from 'axios'
import { findEstoques, findOtimizado } from '@/api/estoque'
import { RomaneioForm } from '@/models/Romaneio'
import { findRomaneio, salvarRomaneio, update } from '@/api/romaneio'


@injectable()
export class EstoqueService implements EstoqueServiceAdapter {
	
	update = async (romaneio: RomaneioForm) =>
		await update(romaneio)

	salvarRomaneio = async (romaneioForm: RomaneioForm) => 
		await salvarRomaneio(romaneioForm)

	findRomaneio = async (depositoId: string) => await findRomaneio(depositoId)

	create = async (idDeposito: string, estoque: FormDeItemDeEstoque) =>
		await createEstoque(idDeposito, estoque)

	add = async (idEstoque: string, qtde: number) =>
		await adicionarQtdeEstoque(idEstoque, qtde)

	retirar = async (idEstoque: string, qtde: number) =>
		await retirarQtdeEstoque(idEstoque, qtde)

	empenhar = async (idEstoque: string, qtde: number) =>
		await empenharEstoque(idEstoque, qtde)

	reaver = async (idEstoque: string, qtde: number) =>
		await reaverEstoque(idEstoque, qtde)

	remove = async (idDeposito: string, idEstoque: string) =>
		await deletarEstoque(idDeposito, idEstoque)

	montar = async (
		idDeposito: string,
		conversaoForm: FormDeConversaoDeEstoque,
	) => await montarEstoque(idDeposito, conversaoForm)

	desmontar = async (
		idDeposito: string,
		conversaoForm: FormDeConversaoDeEstoque,
	) => await desmontarEstoque(idDeposito, conversaoForm)

	async findEstoques(params?: FiltroDeEstoques, config?: AxiosRequestConfig): Promise<Page<Estoque>>{
		return await findEstoques(params, config)
	}
	
	buscarEstoques = async(
		params?: FiltroDaTelaDeEstoques,
		config?: AxiosRequestConfig,
	) => await buscarEstoques(params, config)

	get = async (idDeposito: string, idEstoque: string) =>
		await getEstoque(idDeposito, idEstoque)

	encontrarProdutoComEstoque = async (identificador: string, loja: string) =>
		await encontrarProdutoComEstoque(identificador, loja)

	encontrarProdutoComEstoqueRomaneio = async (identificador: string, loja: string, quantidade: number, tipoDeMovimentacao: string) =>
		await encontrarProdutoComEstoqueRomaneio(identificador, loja, quantidade, tipoDeMovimentacao)


	importaItens = async (idLoja: string, itens: EstoqueCsvForm[]) =>
		await importaItens(idLoja, itens)

	getEstoqueDoItemDaVendaNaLoja = async (idProduto: string, quantidadeDeItens: string, idLoja: string) =>
		await getEstoqueDoItemDaVendaNaLoja(idProduto, quantidadeDeItens, idLoja)

	findOtimizado = async (params?: any, config?: AxiosRequestConfig) => await findOtimizado(params, config)

	exportEstoque = async (idTabela: string) => 
		await exportEstoque(idTabela)

	alterarEstoqueMinimo = async (idEstoque: string, qtdeEstoqueMinimo: EstoqueProjection ) => await  alterarEstoqueMinimo(idEstoque, qtdeEstoqueMinimo)
}
